/**
 * @description 获取角色名称以中文“、”隔开的字符串
 */
export const getRoleNameStr = (role: Array<string>) => {
  if (!role.length) return;
  // const list = role.map(item => item.recipientName);
  return role.join('、');
};
